var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconImageCrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "463px",
    height: "476px",
    viewBox: "0 0 463 476",
    xmlns: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#BFBBCF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 0,
    width: 40,
    height: 380
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 96,
    width: 40,
    height: 380
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 340,
    width: 250,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 92,
    width: 250,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 92,
    width: 67,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 340,
    width: 67,
    height: 40
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageCrop);
export default __webpack_public_path__ + "static/media/icon-image-crop.cc91fd844638e9f93a86eb1bf74856bf.svg";
export { ForwardRef as ReactComponent };